module.exports = ['search.helpers.items.favorite.artists.m1'];
